import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { Input, Label } from "reactstrap"
import { updateMediaCaption } from "store/actions"

const MediaCaption = ({
  initialCaption,
  eventId,
  galleryId,
  vendorId,
  updateMediaCaption,
}) => {
  const captionRef = useRef(null)
  const [caption, setCaption] = useState("")

  useEffect(() => {
    setCaption(initialCaption)
  }, [initialCaption])

  useEffect(() => {
    if (captionRef && captionRef?.current) {
      captionRef.current.style.height = "0px"
      const scrollHeight = captionRef.current?.scrollHeight
      captionRef.current.style.height = scrollHeight + "px"
    }
  }, [captionRef, caption])

  return (
    <div
      className="form-floating"
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <textarea
        ref={captionRef}
        style={{ resize: "none", overflow: "hidden" }}
        type="textarea"
        className="form-control"
        // placeholder="Caption/title"
        value={caption}
        onChange={event => {
          setCaption(event.target.value)
        }}
        onBlur={() => {
          updateMediaCaption({
            caption: caption,
            event_id: eventId,
            gallery_id: galleryId,
            vendor_id: vendorId,
          })
        }}
      />
      <Label size="sm">Caption/title</Label>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  updateMediaCaption: values => dispatch(updateMediaCaption(values)),
})

export default connect(null, mapDispatchToProps)(MediaCaption)
